import $ from 'jquery';
import { disableBodyScroll } from 'body-scroll-lock';
import closeAllMenus from '../../core/INF-closeAllMenus';

export default function() {
  const state = '[data-state]';
  const search_toggle = '[data-search-toggle]';
  const search_drawer = '[data-search-drawer]';

  // HAMBURGER
  $(document).on('click', '[data-hamburger]', () => {
    if ($(state).hasClass('State--mobile-menu-open')) {
      return closeAllMenus();
    }

    closeAllMenus();
    $(state).addClass('State--mobile-menu-open');
    disableBodyScroll($('[data-mobile-menu]')[0]);

    return $(document).trigger('scroll');
  });

  // Close mobile menu if you open it then trip the breakpoint (tablet portrait with menu open -> tablet landscape for example)
  $(window).on('resize', () => {
    if ($(state).hasClass('State--mobile-menu-open') && $('[data-hamburger]').is(':visible') === false) {
      // The mobile menu is open but we're no longer on a mobile breakpoint (hamburger isn't visible)
      closeAllMenus();
    }
  });
 
  // SEARCH
  $(document).on('click', search_toggle, () => {
    if ($(search_drawer).hasClass('SearchDrawer--open')) {
      closeAllMenus();
      return $(document).trigger('scroll');
    }

    closeAllMenus();
    $(search_toggle).addClass('IconToggle--open');
    $(search_drawer).addClass('SearchDrawer--open');
    $(search_drawer).find('input').focus();
    $('[data-site-overlay]').addClass('SiteOverlay--active');
    return $(document).trigger('scroll');
  });
}

export {
  closeAllMenus,
};